import { PlayerClassType } from "../../enum/PlayerClassType";
import { MetersToUnits, toPixels } from "../../util";
import Player from "../Player";
import PlayerClass from "../PlayerClass";
import Gun from "../Gun";
import Cloak from "../abilities/sniper/Cloak";
import TargetLock from "../abilities/sniper/TargetLock";
import OverchargedShot from "../abilities/sniper/OverchargedShot";
import Railgun from "../guns/sniper/Railgun";
import DaggerMines from "../guns/sniper/DaggerMines";

export default class Sniper extends PlayerClass {

    constructor(player: Player) {
        super(PlayerClassType.Sniper, player, new Railgun(player), new DaggerMines(player));

        this.player.hp = this.player.maxHp = 600;
        this.player.energy = this.player.maxEnergy = 80;
        this.player.accelerationForce = toPixels(MetersToUnits(100));
        this.player.size = 8;

        this.abilities = [
            new Cloak(this.player),
            new TargetLock(this.player),
            new OverchargedShot(this.player)
        ];
    }

    Draw(color: string): void {
        this.ctx.strokeStyle = color;
        this.ctx.fillStyle = color + "55";
        this.ctx.lineWidth = 1;

        //draw player
        const p1 = this.player.transform.position.add(this.player.transform.forward.scale(this.player.size));
        const p2 = this.player.transform.position.add(this.player.transform.right.rotate(Math.PI/3).scale(this.player.size));
        const p3 = this.player.transform.position.add(this.player.transform.back.scale(this.player.size));
        const p4 = this.player.transform.position.add(this.player.transform.left.rotate(-Math.PI/3).scale(this.player.size));

        this.player.engine.fillShape(p1, p2, p3, p4);
        this.player.engine.strokeShape(p1, p2, p3, p4);
        //

        super.Draw(color);
    }

}